import { ReconciliationCompanyStatus, ReconciliationRunStatus } from 'app/types/reconciliations';

export const ReconciliationRunStatusValues: Record<
  ReconciliationRunStatus,
  { color: string; value: string }
> = {
  QUEUED: { color: 'created', value: 'Queued' },
  RUNNING: { color: 'invited', value: 'Running' },
  COMPLETED: { color: 'active', value: 'Completed' },
  FAILED: { color: 'left', value: 'Failed' },
};

export const ActiveReconciliationRunStatuses: ReconciliationRunStatus[] = ['QUEUED', 'RUNNING'];

export const ReconciliationReportRowStatusValues: Record<string, { color: string; value: string }> =
  {
    NEW: { color: 'warning', value: 'New' },
    OPEN: { color: 'invited', value: 'Open' },
    NOT_CHECKED: { color: 'disabled', value: 'Not checked' },
  };

export const RECONCILIATION_POLL_INTERVAL_MS = 5000;

export type ReconciliationProfileTabKey =
  | 'problems'
  | 'new'
  | 'resolved'
  | 'past'
  | 'fixed'
  | 'companies'
  | 'not-verifiable';

export const ReconciliationProfileTabs: { key: ReconciliationProfileTabKey; label: string }[] = [
  { key: 'problems', label: 'Problems' },
  { key: 'new', label: 'New problems' },
  { key: 'resolved', label: 'Resolved problems' },
  { key: 'past', label: 'Past, never fixed' },
  { key: 'fixed', label: 'Fixed or accepted' },
  { key: 'companies', label: 'Companies' },
  { key: 'not-verifiable', label: 'Not verifiable' },
];

export const RECONCILIATION_TAB_PARAM = 'tab';
export const RECONCILIATION_COMPANY_STATUS_PARAM = 'companyStatus';

export const ReconciliationCompanyStatusValues: Record<
  ReconciliationCompanyStatus,
  { color: string; value: string }
> = {
  CHECKED: { color: 'active', value: 'Checked' },
  FAILED: { color: 'left', value: 'Failed' },
};

export const RECONCILIATION_DETAILS_NOT_RECORDED =
  'Details were not recorded for this run (it ran before they were kept)';

export default ReconciliationRunStatusValues;

export const SYSTEM_USER_ID = '00000000-0000-0000-0000-000000000000';
